import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './clientManagers.consts';
import { ClientManagerParams } from './clientManagers.types';

function normalizeApiReponse(data: ClientManagerParams) {
  return data;
}

function normalizeApiRequest(data: ClientManagerParams) {
  return data;
}

const fetchByIdHandler = async ({
  clientManagerId,
}: {
  clientManagerId: number;
}) => {
  const client = await adserver({
    url: `/clientmanagers/${clientManagerId}`,
    headers: {},
  });

  return {
    ...client.data,
  };
};

export const fetchAllClientManagers = createAsyncThunk(
  REDUCER_KEY + '/fetchAllClientManagers',
  withErrorHandling(async () => {
    const response = await adserver({
      url: '/clientmanagers/',
      headers: {},
    });
    return normalizeApiReponse(response.data);
  }),
);

export const fetchById = createAsyncThunk(
  REDUCER_KEY + '/get',
  withErrorHandling(
    async ({ clientManagerId }: { clientManagerId: number }) => {
      const response = await adserver({
        url: `/clientmanagers/${clientManagerId}`,
        headers: {},
      });
      return normalizeApiReponse(response.data);
    },
  ),
);

export const create = createAsyncThunk(
  REDUCER_KEY + '/create',
  withErrorHandling(async (values: ClientManagerParams) => {
    const response = await adserver({
      url: '/clientmanagers/',
      method: 'POST',
      data: normalizeApiRequest(values),
      headers: {},
    });
    return normalizeApiReponse(response.data);
  }),
);

export const update = createAsyncThunk(
  REDUCER_KEY + '/update',
  withErrorHandling(async (data: ClientManagerParams) => {
    const { id: clientManagerId } = data;

    const response = await adserver({
      url: `/clientmanagers/${clientManagerId}/`,
      method: 'PATCH',
      data,
      headers: {},
    });
    return response.data;
  }),
);

export const remove = createAsyncThunk(
  REDUCER_KEY + '/remove',
  withErrorHandling(
    async ({ clientManagerId }: { clientManagerId: number }) => {
      await adserver({
        url: `/clientmanagers/${clientManagerId}/`,
        method: 'DELETE',
        headers: {},
      });
      return clientManagerId;
    },
  ),
);

export const setCurrentClientManager = createAsyncThunk(
  REDUCER_KEY + '/setCurrentClientManager',
  withErrorHandling(async (clientManagerId: number) => {
    if (!clientManagerId) return;
    const client = await fetchByIdHandler({ clientManagerId });
    return client;
  }),
);

export const removeAllClientManagers = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});
